"use client";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { SectionTemplate } from "components/individuals/blocks";
import { richTextRenderers } from "components/individuals/mdx-components";
import { ImageFragment } from "lib/gcms";
import dynamic from "next/dynamic";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";

export interface KeyFeaturesSectionProps {
  title: string;
  subtitle: string;
  content: any;
  titleColor: string;
  subtitleColor: string;
  bg: string;
  image: ImageFragment & { alt?: string };
}

const LiteYouTubeEmbed = dynamic(() => import("react-lite-youtube-embed"), {
  ssr: false,
});

export const KeyFeaturesSection = ({
  title,
  subtitle,
  content,
  titleColor,
  subtitleColor,
  bg,
}: KeyFeaturesSectionProps) => {
  return (
    <SectionTemplate bg={bg}>
      <Flex
        columnGap={10}
        align={"center"}
        flexDir={{
          base: "column",
          lg: "row",
        }}
      >
        <Flex
          flexDirection={"column"}
          justify={"center"}
          align={"center"}
          width={{
            lg: "50%",
          }}
        >
          <Heading
            as={"h2"}
            color={titleColor}
            fontSize={{
              base: 26,
              md: 34,
              lg: 38,
              xl: 45,
            }}
            mb={{
              base: 6,
              lg: 8,
            }}
            fontWeight={"bold"}
          >
            {title}
          </Heading>
          <Text
            as={"h3"}
            color={subtitleColor}
            mb={{
              base: 4,
              lg: 6,
            }}
            textAlign={"center"}
            fontWeight={"bold"}
            fontSize={{
              base: 16,
              md: 18,
              lg: 20,
              xl: 22,
            }}
          >
            {subtitle}
          </Text>
          <Box
            fontSize={{
              base: 14,
              md: 16,
              lg: 17,
              xl: 18,
            }}
          >
            <RichText content={content.raw} renderers={richTextRenderers} />
          </Box>
        </Flex>

        <Box
          position={"relative"}
          w={"full"}
          h={0}
          overflow={"hidden"}
          minW={{
            base: "350px",
          }}
          maxW={{
            base: "full",
            md: "70%",
            lg: "50%",
          }}
          pb={{
            base: "60%",
            md: "40%",
            lg: "30%",
          }}
          mt={{
            base: 5,
            lg: 0,
          }}
        >
          <LiteYouTubeEmbed
            id="LrjXjOSthYU"
            title="AreaHub Environmental Intelligence+™ Solutions YouTube video player"
          />
        </Box>
      </Flex>
    </SectionTemplate>
  );
};
